import * as betprofessor from './onboarding.styles.betprofessor';
import * as goldenrush from './onboarding.styles.goldenrush';
import * as juicybet from './onboarding.styles.juicybet';
import * as puntcity from './onboarding.styles.puntcity';
import * as sterlingparker from './onboarding.styles.sterlingparker';
import * as vikingbet from './onboarding.styles.vikingbet';
import * as betroyale from './onboarding.styles.betroyale';
import * as forsport from './onboarding.styles.forsport';
import * as junglebet from './onboarding.styles.junglebet';
import * as oldgill from './onboarding.styles.oldgill';
import * as sugarcastle from './onboarding.styles.sugarcastle';
import * as buffalobet from './onboarding.styles.buffalobet';
import * as titanbet from './onboarding.styles.titanbet';
import * as bet777 from './onboarding.styles.bet777';
import * as gigabet from './onboarding.styles.gigabet';
import * as slambet from './onboarding.styles.slambet';
import * as betstride from './onboarding.styles.betstride';
import * as templebet from './onboarding.styles.templebet';
import * as goldenbet888 from './onboarding.styles.goldenbet888';
import * as hyperbet from './onboarding.styles.hyperbet';
import * as chromabet from './onboarding.styles.chromabet';
import * as bet575 from './onboarding.styles.bet575';
import * as betblast from './onboarding.styles.betblast';
import * as pyramidbet from './onboarding.styles.pyramidbet';
import * as magnumbet from './onboarding.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  goldenrush,
  juicybet,
  puntcity,
  sterlingparker,
  vikingbet,
  betroyale,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
